import React from 'react';
import axios from 'axios';
import SelectedScenario from "./SelectedScenario";
import GetCSRFToken from "../../AuthComponents/GetCSRFToken";


function outProcessSelectedScenarioList(ssl: SelectedScenario[]) {
    if (ssl === undefined) {
      return {
        configuredScenarios: [],
      };
    }
    return {
      configuredScenarios: ssl.map((selectedScenario) => ({
        ...selectedScenario,
        scenarioDisplayProps: null,
        currentlyDisplayed: false,
      })),
    };
  }

function PostSelectedScenarioList(ssl: SelectedScenario[], handleSuccessNotification: () => void) {
    axios
      .post("/api/scenario/configured", outProcessSelectedScenarioList(ssl), {
        headers: { "X-CSRFToken": GetCSRFToken() },
      })
      .then((res) => {
        handleSuccessNotification();
      })
      .catch((error) => {
        if (process.env.NODE_ENV === "development") {
              console.log(error.response);
            }; // TODO: instead of closing dialogue communicate about the error
      })
      .finally(() => {});
  }

export default PostSelectedScenarioList;